import PreviewSection from '../../PreviewSection'

export default function TTDetailHTMLPreviewTotalSection() {}

TTDetailHTMLPreviewTotalSection.prototype = new PreviewSection();

TTDetailHTMLPreviewTotalSection.prototype.constructor = TTDetailHTMLPreviewTotalSection;

TTDetailHTMLPreviewTotalSection.prototype.init = function( nDetailCells, timeFormat){
    PreviewSection.prototype.init.call(this)

    this.nDetailCells = nDetailCells;
    this.timeFormat = timeFormat;

    return this;
};

TTDetailHTMLPreviewTotalSection.prototype.addRows = function( tBody ) {
    const row = this.createRow()
    this.addCell( row, this.message("report.total"), "totalCell", this.nDetailCells );
    ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat, "spent");
    ReportPreviewUtils.addEmptyCell(row);
    this.addRow(tBody, row);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/ttdetail/TTDetailHTMLPreviewTotalSection.js